import * as Sentry from '@sentry/vue';
import {
  DRIVER_PLANNING,
  DRIVER_MISSION_DETAIL,
} from '@/services/constants/storageKeys';

/**
 * Always use this function to set items in localStorage to always try catch errors
 * Error can happen if the storage is full (for example)
 */
function setItemSafe(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (e) {
    // send sentry error anyway
    Sentry.captureException(e);

    // if error is QuotaExceededError, we remove planning data (we assume it's the biggest data in localStorage)
    if (
      e instanceof DOMException &&
      (e.name === 'QuotaExceededError' ||
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED')
    ) {
      clearPlanningData();
    }
  }
}

function clearPlanningData() {
  window.localStorage.removeItem(DRIVER_PLANNING);
  window.localStorage.removeItem(DRIVER_MISSION_DETAIL);
}

export { setItemSafe, clearPlanningData };
